import { CardSuit } from "../card/Card";
import { LoaderFileKeys } from "../constant/AppConstants";
import { IconButton } from "../../ui/IconButton";
import { LabelButton } from "../../ui/LabelButton";
import { TablePopupWindow } from "./TablePopupWindow";
import { ButtonBase, ButtonEvents } from "../../ui/ButtonBase";
import { AppSettings } from "../managers/AppSettings";
import { LabelIconButton } from "../../ui/LabelIconButton";
import { RectSize } from "../../utils/RectSize";
import { IInteractive } from "../../interfaces/IInteractive";
import { AppLocalization, LanguageId } from "../localization/AppLocalization";
import { LayoutDataManager } from "../managers/LayoutDataManager";
import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { PopupBiddingChoiceType } from "./PopupBiddingTakeSuit";


export enum PopupChooseSuitLayoutType {
    WITH_NT_AT,
    NO_NT_AT,
}

export class PopupBiddingChooseSuit
    extends TablePopupWindow {
    public nsContentBg: Phaser.GameObjects.NineSlice;
    public nsContentBgExtrusion: number = 25; // extrude to cover for outer drop shadow size
    public nsHeaderBg: Phaser.GameObjects.NineSlice;
    public txtHeader: Phaser.GameObjects.Text;
    public btnSuitSpades: IconButton;
    public btnSuitClubs: IconButton;
    public btnSuitDiamonds: IconButton;
    public btnSuitHearts: IconButton;
    public btnNoTrumps: LabelIconButton;
    public btnAllTrumps: LabelIconButton;
    public btnPass: LabelButton;
    protected layoutsData = [
        // WITH_NT_AT
        {
            bg: {
                width: 500, height: 500,
            },
            btnSuitSpades: {
                x: -100, y: -150,
            },
            btnSuitHearts: {
                x: 100, y: -150,
            },
            btnSuitClubs: {
                x: -100, y: -50,
            },
            btnSuitDiamonds: {
                x: 100, y: -50,
            },
            btnNoTrumps: {
                x: -100, y: 50,
            },
            btnAllTrumps: {
                x: 100, y: 50,
            },
            btnPass: {
                x: 0, y: 150
            }
        },
        // NO_NT_AT
        {
            bg: {
                width: 500, height: 400,
            },
            btnSuitSpades: {
                x: -100, y: -100,
            },
            btnSuitHearts: {
                x: 100, y: -100,
            },
            btnSuitClubs: {
                x: -100, y: 0,
            },
            btnSuitDiamonds: {
                x: 100, y: 0,
            },
            btnPass: {
                x: 0, y: 100
            }
        }
    ];
    protected curLayoutType: PopupChooseSuitLayoutType;
    /**
     * Vache additionally modifies the layout, removing the PASS button, if set to TRUE
     */
    protected isVache: boolean;
    /**
     * Auto-enable on Show and auto-disable on Hide all interactives eg buttons
     */
    protected interactives: IInteractive[];


    public override Init(): void {
        // >> create screenOverlayHitArea
        super.Init();

        this.interactives = [];
    }

    public override Build(): void {
        // console.log("PopupBiddingSub::Build");

        const btnScale: number = 0.8;
        const btnIconScale: number = 1.0;

        // content bg
        const nsContentBgBorderSize = 55;
        this.nsContentBg = this.scene.make.nineslice({
            key: LoaderFileKeys.ui,
            frame: "rect-black-w72-r24-A80-ds.png",
            leftWidth: nsContentBgBorderSize,
            rightWidth: nsContentBgBorderSize,
            topHeight: nsContentBgBorderSize,
            bottomHeight: nsContentBgBorderSize,
            // alpha: 0.9, // texture already has an alpha?
        });
        this.add(this.nsContentBg);

        // header bg
        const nsHeaderBgBorderSize = 46;
        this.nsHeaderBg = this.scene.make.nineslice({
            key: LoaderFileKeys.ui,
            frame: "bidPopup-header-bg.png",
            leftWidth: nsHeaderBgBorderSize,
            rightWidth: nsHeaderBgBorderSize,
        });
        this.add(this.nsHeaderBg);

        // header title
        this.txtHeader = this.scene.make.text({
            style: {
                color: AppSettings.colors.whiteString,
                fontSize: "30px",
                align: "center",
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                metrics: AppSettings.metrics.montserratBold30,
            }
        });
        this.txtHeader.setOrigin(0.5);
        this.add(this.txtHeader);

        // btnSuitSpades
        this.btnSuitSpades = new IconButton(this.scene);
        this.btnSuitSpades.setData({ choiceType: PopupBiddingChoiceType.SPADES });
        this.btnSuitSpades.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnSuitSpades.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-choice-spades-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "icon-choice-spades-disabled.png" },
        }, null, btnIconScale);
        this.btnSuitSpades.PostInit(20); // sets interactive
        this.btnSuitSpades.setScale(btnScale);
        this.interactives.push(this.btnSuitSpades);
        this.add(this.btnSuitSpades);

        // hearts
        this.btnSuitHearts = new IconButton(this.scene);
        this.btnSuitHearts.setData({ choiceType: PopupBiddingChoiceType.HEARTS });
        this.btnSuitHearts.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnSuitHearts.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-choice-hearts-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "icon-choice-hearts-disabled.png" },
        }, null, btnIconScale);
        this.btnSuitHearts.PostInit(20);
        this.btnSuitHearts.setScale(btnScale);
        this.interactives.push(this.btnSuitHearts);
        this.add(this.btnSuitHearts);

        // clubs
        this.btnSuitClubs = new IconButton(this.scene);
        this.btnSuitClubs.setData({ choiceType: PopupBiddingChoiceType.CLUBS });
        this.btnSuitClubs.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnSuitClubs.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-choice-clubs-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "icon-choice-clubs-disabled.png" },
        }, null, btnIconScale);
        this.btnSuitClubs.PostInit(20);
        this.btnSuitClubs.setScale(btnScale);
        this.interactives.push(this.btnSuitClubs);
        this.add(this.btnSuitClubs);

        // diamonds
        this.btnSuitDiamonds = new IconButton(this.scene);
        this.btnSuitDiamonds.setData({ choiceType: PopupBiddingChoiceType.DIAMONDS });
        this.btnSuitDiamonds.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnSuitDiamonds.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-choice-diamonds-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "icon-choice-diamonds-disabled.png" },
        }, null, btnIconScale);
        this.btnSuitDiamonds.PostInit(20);
        this.btnSuitDiamonds.setScale(btnScale);
        this.interactives.push(this.btnSuitDiamonds);
        this.add(this.btnSuitDiamonds);

        // btnNoTrumps
        this.btnNoTrumps = new LabelIconButton(this.scene);
        // this.btnNoTrumps.name = "btnNoTrumps";
        this.btnNoTrumps.setData({ choiceType: PopupBiddingChoiceType.NOTRUMPS });
        this.btnNoTrumps.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnNoTrumps.InitLabel(
            {
                out: {
                    color: "#000",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
                disabled: {
                    color: "#999",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
            },
            new Phaser.Geom.Point(20, 0)
        );
        this.btnNoTrumps.label.setOrigin(0.5);
        this.btnNoTrumps.InitIcon({
            out: { texture: LoaderFileKeys.cardsDeck, frame: LayoutDataManager.GetSharedData().general.noTrumpsIconFrame.out },
            disabled: { texture: LoaderFileKeys.cardsDeck, frame: LayoutDataManager.GetSharedData().general.noTrumpsIconFrame.disabled },
        }, new Phaser.Geom.Point(-50, 0), btnIconScale);
        this.btnNoTrumps.PostInit(20);
        this.btnNoTrumps.setScale(btnScale);
        this.interactives.push(this.btnNoTrumps);
        this.add(this.btnNoTrumps);

        // btnAllTrumps
        this.btnAllTrumps = new LabelIconButton(this.scene);
        // this.btnAllTrumps.name = "btnAllTrumps";
        this.btnAllTrumps.setData({ choiceType: PopupBiddingChoiceType.ALLTRUMPS });
        this.btnAllTrumps.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnAllTrumps.InitLabel(
            // label states data
            {
                out: {
                    color: "#000",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
                disabled: {
                    color: "#999",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
            },
            // label offset
            new Phaser.Geom.Point(20, 0),
        );
        this.btnAllTrumps.label.setOrigin(0.5);
        this.btnAllTrumps.InitIcon({
            out: { texture: LoaderFileKeys.cardsDeck, frame: LayoutDataManager.GetSharedData().general.allTrumpsIconFrame.out },
            disabled: { texture: LoaderFileKeys.cardsDeck, frame: LayoutDataManager.GetSharedData().general.allTrumpsIconFrame.disabled },
        }, new Phaser.Geom.Point(-50, 0), btnIconScale);
        this.btnAllTrumps.PostInit(20);
        this.btnAllTrumps.setScale(btnScale);
        this.interactives.push(this.btnAllTrumps);
        this.add(this.btnAllTrumps);

        // pass
        this.btnPass = new LabelButton(this.scene);
        this.btnPass.setData({ choiceType: PopupBiddingChoiceType.PASS });
        this.btnPass.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-oval3-bg-out.png" },
        });
        this.btnPass.InitLabel(
            {
                out: {
                    color: "#000",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
                disabled: {
                    color: "#999",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                }
            }
        );
        this.btnPass.label.setOrigin(0.5);
        this.btnPass.PostInit(20);
        this.btnPass.setScale(btnScale);
        this.interactives.push(this.btnPass);
        this.add(this.btnPass);
    }

    public override Show(animated: boolean = true): void {
        super.Show(animated);
        this.SetInteractive(true);
    }

    public override Hide(animated: boolean = true): void {
        super.Hide(animated);
        this.SetInteractive(false);
    }

    public GetCurrentLayoutType(): PopupChooseSuitLayoutType {
        return this.curLayoutType;
    }

    /**
     * SetLayout and UpdateView
     * @param layoutType 
     * @param isVache Additional on top of Layout setting, this further modifies the layout but showing (FALSE) or hiding (TRUE) the PASS button
     */
    public SetLayoutType(layoutType: PopupChooseSuitLayoutType): void {
        if (layoutType != this.curLayoutType) {
            this.curLayoutType = layoutType;
        }
    }

    public UpdateView(): void {
        const curLayoutData = this.layoutsData[this.curLayoutType];

        let additionalBgHeight: number = 0;
        let additionalItemOffsetY: number = 0;

        const showPass = this.inputData.disabledChoices.indexOf(PopupBiddingChoiceType.PASS) == -1;
        if (!showPass) {
            additionalBgHeight = -100;
            additionalItemOffsetY += 50;
        }

        this.nsContentBg.setSize(
            curLayoutData.bg.width + 2 * this.nsContentBgExtrusion,
            curLayoutData.bg.height + 2 * this.nsContentBgExtrusion + additionalBgHeight
        );
        this.txtHeader.y =
            this.nsHeaderBg.y = -(curLayoutData.bg.height + additionalBgHeight) * 0.5;

        this.btnSuitSpades.setPosition(curLayoutData.btnSuitSpades.x, curLayoutData.btnSuitSpades.y + additionalItemOffsetY);
        this.btnSuitHearts.setPosition(curLayoutData.btnSuitHearts.x, curLayoutData.btnSuitHearts.y + additionalItemOffsetY);
        this.btnSuitClubs.setPosition(curLayoutData.btnSuitClubs.x, curLayoutData.btnSuitClubs.y + additionalItemOffsetY);
        this.btnSuitDiamonds.setPosition(curLayoutData.btnSuitDiamonds.x, curLayoutData.btnSuitDiamonds.y + additionalItemOffsetY);

        if (curLayoutData.btnNoTrumps != undefined) {
            this.btnNoTrumps.setPosition(curLayoutData.btnNoTrumps.x, curLayoutData.btnNoTrumps.y + additionalItemOffsetY);
            this.btnNoTrumps.visible = true;
        }
        else {
            this.btnNoTrumps.visible = false;
        }

        if (curLayoutData.btnAllTrumps != undefined) {
            this.btnAllTrumps.setPosition(curLayoutData.btnAllTrumps.x, curLayoutData.btnAllTrumps.y + additionalItemOffsetY);
            this.btnAllTrumps.visible = true;
        }
        else {
            this.btnAllTrumps.visible = false;
        }

        if (!showPass) {
            this.btnPass.visible = false;
        }
        else {
            this.btnPass.setPosition(curLayoutData.btnPass.x, curLayoutData.btnPass.y + additionalItemOffsetY);
            this.btnPass.visible = true;
        }
    }

    /**
     * SetInteractive on all children
     */
    public SetInteractive(value: boolean): void {
        let setEnabled: boolean = false;
        for (let i = 0; i < this.interactives.length; i++) {
            const btn = this.interactives[i];
            const btnChoiceIndex: PopupBiddingChoiceType = (btn as ButtonBase).getData("choiceType");
            if (this.inputData != undefined && this.inputData.disabledChoices != undefined) {
                // if button should be disabled
                if (this.inputData.disabledChoices.indexOf(btnChoiceIndex) != -1) {
                    setEnabled = false;
                }
                else {
                    setEnabled = value;
                }
            }
            else {
                setEnabled = value;
            }

            // apply interactivity and listeners
            btn.SetInteractive(setEnabled);
            if (setEnabled) {
                (btn as ButtonBase).on(ButtonEvents.CLICK, this.OnButtonClicked, { root: this, target: btn });
            }
            else {
                (btn as ButtonBase).off(ButtonEvents.CLICK, this.OnButtonClicked);
            }
        }
    }

    public OnButtonClicked(): void {
        // console.log("OnButtonClicked");

        const root: PopupBiddingChooseSuit = this["root"] as PopupBiddingChooseSuit;
        const btn: ButtonBase = this["target"] as ButtonBase;
        const choiceType: number = btn.getData("choiceType");

        // button click
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click5);

        root.Hide();
        root.inputData.onComplete(root.inputData.taskType, { choiceType: choiceType });
    }

    /**
     * cancel base functionality
     * - PopupWindow::screenOverlay will NOT be drawn
     */
    public override OnResize(windowRect: RectSize): void { }

    public UpdateViewFromLocalizationChange(languageId: LanguageId): void {
        // header ribbon
        this.txtHeader.text = AppLocalization.GetSharedData(languageId).table.bidding.popup.headerLabel;
        this.btnNoTrumps.label.text = AppLocalization.GetSharedData(languageId).general.noTrumpsShortText;
        this.btnAllTrumps.label.text = AppLocalization.GetSharedData(languageId).general.allTrumpsShortText;
        this.btnPass.label.text = AppLocalization.GetSharedData(languageId).table.declarations.pass;

        // stretch header bg to label width + padding
        this.nsHeaderBg.width = this.txtHeader.width + 2 * LayoutDataManager.GetSharedData().table.bidding.popup.header.padding.horizontal;
    }
}